import React, { useEffect, useState, useCallback } from "react";
import { Sparklines, SparklinesLine } from 'react-sparklines';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import moment from 'moment';
import Stats from "../../../components/Elements/StatsPlotly";
import Widget from "../../../components/Elements/Widget";
import { SETTING_SEASON_YEAR } from "../../../utils/settings";
import { useStore } from "../../../providers/AppProvider";
import { dcRound } from "../../../utils/misc";
//import { StatValue } from "../../types/types";

type StatsProps = {
    metric: string
    description: string,
    loading: boolean,
    dataSpark1: any | null,
    dataSpark3: any | null,
    dataSpark2: any | null,
    propertyUnitsData: any | null,
    dateSelected: string | null,
}

const AboveWidget3SparkCell = ({ 
    metric, 
    description, 
    loading, 
    dataSpark3, 
    dataSpark1, 
    dataSpark2,
    propertyUnitsData,
    dateSelected
}: StatsProps) => {
    let topStart = -32;
    let topEnd = -48;
    let leftAdjustEnd = "12.5px";
    let leftAdjustStart = "12.5px";

    const { state, settings } = useStore();
    console.log("A080224 dataSpark1", dataSpark1)
    console.log("A080224 dataSpark2", dataSpark2)
    console.log("A080224 dataSpark3", dataSpark3)
    /*console.log("A062524 loading", loading)
    console.log("A062524 description", description)
    console.log("A062524 metric", metric)
    console.log("A062524 propertyUnitsData", propertyUnitsData)*/
    let sparkDays1, sparkStartDays1, sparkEndDays1, totalDays1, sparkWidth1, sparkLeft1, maxDateLabel1, minDateLabel1, yearStartFormatted1, yearEndFormatted1;
    if (dataSpark1 && dataSpark1[3]){
        let sparkMoments1 = dataSpark1[3].map((d:any) => d ? moment(d) : null);
        //sparkMoments1 = sparkMoments1.filter((d:any) => d !== null); // Moment.js will fail if it encounters a null value, so remove them.
        //console.log("B031524 sparkMoments1", sparkMoments1);
        //console.log("B031524 dataSpark1", dataSpark1);
        let maxDate1 = moment.utc(moment.max(sparkMoments1));
        let minDate1 = moment.utc(moment.min(sparkMoments1));
        maxDateLabel1 = maxDate1.format("MM-DD")
        minDateLabel1 = minDate1.format("MM-DD")
        sparkDays1 = maxDate1.diff(minDate1, 'days');
        let yearStart1 = moment(dataSpark1[4][0])
        sparkStartDays1 = minDate1.diff(yearStart1, 'days')
        let yearEnd1 = moment(dataSpark1[4][1])
        yearStartFormatted1 = (parseInt(yearStart1.format("YYYY")) - 1).toString()
        yearEndFormatted1 = yearEnd1.format("YYYY")
        sparkEndDays1 = maxDate1.diff(yearStart1, 'days')
        totalDays1 = yearEnd1.diff(yearStart1, 'days')
        sparkWidth1 = 100 * (sparkDays1 / totalDays1);
        sparkLeft1 = 100 * (sparkStartDays1 / totalDays1);
        if (dataSpark1[0] === "Bloom Index"){
            sparkWidth1 = 95;
            sparkLeft1 = 2.5;
            maxDateLabel1 = maxDateLabel1 + "-" + yearEndFormatted1;
            minDateLabel1 = minDateLabel1 + "-" + yearEndFormatted1;
            yearStartFormatted1 = "";
            yearEndFormatted1 = "";
            topStart = 0;
            topEnd = -15;
            leftAdjustEnd = "45px";
            leftAdjustStart = "11px";
        }
        //if (sparkWidth1 <= 0){ sparkWidth1 = 1 };
    }
    let sparkDays2, sparkStartDays2, sparkEndDays2, totalDays2, sparkWidth2, sparkLeft2, maxDateLabel2, minDateLabel2, yearStartFormatted2, yearEndFormatted2;
    if (dataSpark2 && dataSpark2[3]){
        let sparkMoments2 = dataSpark2[3].map((d:any) => d ? moment(d) : null);
        let maxDate2 = moment.utc(moment.max(sparkMoments2));
        let minDate2 = moment.utc(moment.min(sparkMoments2));
        maxDateLabel2 = maxDate2.format("MM-DD")
        minDateLabel2 = minDate2.format("MM-DD")
        sparkDays2 = maxDate2.diff(minDate2, 'days');
        let yearStart2 = moment(dataSpark2[4][0])
        sparkStartDays2 = minDate2.diff(yearStart2, 'days')
        let yearEnd2 = moment(dataSpark2[4][1])
        yearStartFormatted2 = (parseInt(yearStart2.format("YYYY")) - 1).toString()
        yearEndFormatted2 = yearEnd2.format("YYYY")
        sparkEndDays2 = maxDate2.diff(yearStart2, 'days')
        totalDays2 = yearEnd2.diff(yearStart2, 'days')
        sparkWidth2 = 100 * (sparkDays2 / totalDays2);
        sparkLeft2 = 100 * (sparkStartDays2 / totalDays2);
        //if (sparkWidth2 <= 0){ sparkWidth2 = 1 };
    }
    let sparkDays3, sparkStartDays3, sparkEndDays3, totalDays3, sparkWidth3, sparkLeft3, maxDateLabel3, minDateLabel3, yearStartFormatted3, yearEndFormatted3;
    if (dataSpark3 && dataSpark3[3]){
        let sparkMoments3 = dataSpark3[3].map((d:any) => d ? moment(d) : null);
        let maxDate3 = moment.utc(moment.max(sparkMoments3));
        let minDate3 = moment.utc(moment.min(sparkMoments3));
        maxDateLabel3 = maxDate3.format("MM-DD")
        minDateLabel3 = minDate3.format("MM-DD")
        sparkDays3 = maxDate3.diff(minDate3, 'days');
        let yearStart3 = moment(dataSpark3[4][0])
        sparkStartDays3 = minDate3.diff(yearStart3, 'days')
        let yearEnd3 = moment(dataSpark3[4][1])
        yearStartFormatted3 = (parseInt(yearStart3.format("YYYY")) - 1).toString()
        yearEndFormatted3 = yearEnd3.format("YYYY")
        sparkEndDays3 = maxDate3.diff(yearStart3, 'days')
        totalDays3 = yearEnd3.diff(yearStart3, 'days')
        sparkWidth3 = 100 * (sparkDays3 / totalDays3);
        sparkLeft3 = 100 * (sparkStartDays3 / totalDays3);
        //if (sparkWidth3 <= 0){ sparkWidth3 = 1 };
    }

    const [data1, setData1] = useState<any>(null);
    const [data2, setData2] = useState<any>(null);
    const [data3, setData3] = useState<any>(null);

    function sortJsonByDate(data:any) {
        // Convert the dates to Date objects for sorting
        let dates = data.dates.map((date:any) => new Date(date));
    
        // Pair dates with values and sort by dates
        let pairedData = dates.map((date:any, index:number) => [date, data.values[index]]);
        pairedData.sort((a:any, b:any) => a[0] - b[0]);
    
        // Separate the sorted dates and values
        let sortedDates = pairedData.map((pair:any) => pair[0].toISOString());
        let sortedValues = pairedData.map((pair:any) => pair[1]);
    
        // Create the output JSON structure
        let sortedData = {
            dates: sortedDates,
            values: sortedValues,
            max: data.max,
            min: data.min,
        };
    
        return sortedData;
    }

    useEffect(() => {
        console.log("A062524 dataSpark1", dataSpark1)
        console.log("A062524 dateSelected", dateSelected)
        if(loading || !dataSpark1 || !dataSpark1[3] || !dataSpark1[2] || (dataSpark1[2].length === 1 && !dataSpark1[2][0])|| (dataSpark1[3].length === 1 && !dataSpark1[3][0])) {
            setData1(null);
            return;
        }
        let onlyOneValue = 0;
        let singleValue = 0;
        let singleDate = "";
        dataSpark1[2].forEach((d:any, i:number) => {
            if (d !== null){
                onlyOneValue++;
                singleValue = d;
                singleDate = dataSpark1[3][i];
            }
        });

        setData1({
            data: sortJsonByDate({
                dates:dataSpark1[3],
                values:dataSpark1[2],
                min:dataSpark1[5],
                max:dataSpark1[6] 
            }),
            name: dataSpark1[0],    
            description: dataSpark1[1], 
            onlyOneValue:  onlyOneValue === 1 ? true : false,
            singleValue: singleValue,  
            singleDate: singleDate,
        });
    }, [dataSpark1, dateSelected]);

    useEffect(() => {
        console.log("A062524 dataSpark2", dataSpark2)
        console.log("A062524 dateSelected", dateSelected)
        if(loading || !dataSpark2 || !dataSpark2[3] || !dataSpark2[2] || (dataSpark2[2].length === 1 && !dataSpark2[2][0])|| (dataSpark2[3].length === 1 && !dataSpark2[3][0])) {
            setData2(null);
            return;
        }
        let onlyOneValue = 0;
        let singleValue = 0;
        let singleDate = "";
        dataSpark2[2].forEach((d:any, i:number) => {
            if (d !== null){
                onlyOneValue++;
                singleValue = d;
                singleDate = dataSpark2[3][i];
            }
        });
        setData2({
            data: sortJsonByDate({
                dates:dataSpark2[3],
                values:dataSpark2[2],
                min:dataSpark2[5],
                max:dataSpark2[6] 
            }),
            name: dataSpark2[0],    
            description: dataSpark2[1],  
            onlyOneValue: onlyOneValue === 1 ? true : false,
            singleValue: singleValue,
            singleDate: singleDate,
        });
    }, [dataSpark2, dateSelected]);

    useEffect(() => {
        console.log("A062524 dataSpark3", dataSpark3)
        console.log("A062524 dateSelected", dateSelected)
        if(loading || !dataSpark3 || !dataSpark3[3] || !dataSpark3[2] || (dataSpark3[2].length === 1 && !dataSpark3[2][0])|| (dataSpark3[3].length === 1 && !dataSpark3[3][0])){
            setData3(null);
            return;
        }
        let onlyOneValue = 0;
        let singleValue = 0;
        let singleDate = "";
        dataSpark3[2].forEach((d:any, i:number) => {
            if (d !== null){
                onlyOneValue++;
                singleValue = d;
                singleDate = dataSpark3[3][i];
            }
        });
        setData3({
            data: sortJsonByDate({
                dates:dataSpark3[3],
                values:dataSpark3[2],
                min:dataSpark3[5],
                max:dataSpark3[6] 
            }),
            name: dataSpark3[0],    
            description: dataSpark3[1], 
            onlyOneValue: onlyOneValue === 1 ? true : false,
            singleValue: singleValue,
            singleDate: singleDate,
        });
    }, [dataSpark3, dateSelected]);

    return (
        <div style={{overflowX: "hidden"}}>
            <dd>
                { console.log("C080524 dataSpark1", dataSpark1) }
                { console.log("C080524 dataSpark2", dataSpark2) }
                { console.log("C080524 dataSpark3", dataSpark3) }
                { console.log("C080524 loading", loading) }
                { /*{ console.log("C031524 sparkWidth1", sparkWidth1) }
                { console.log("C031524 sparkWidth2", sparkWidth2) }
                { console.log("C031524 sparkWidth3", sparkWidth3) */}
                { loading && <div className="text-muted text-sm mt-2">Loading...</div> }
                { !loading && !data1 && !data2 && !data3 
                ?
                    <>
                    {/*console.log("C031524 A")*/}
                    <div className="text-muted text-sm mt-2">Data not available</div>
                    </>
                :   <>
                    {/*console.log("C031524 B")*/}
                    {
                    ( dataSpark1 && data1 && sparkWidth1 && sparkWidth1 > 0 && data1.onlyOneValue === false)
                    ? <>
                        <Widget title={data1.name} showHeader={false} renderActions={() => (<></>)}>
                            <Stats year={settings[SETTING_SEASON_YEAR]} dateSelected={dateSelected} loading={loading} metric={data1.name} description={data1.description} data={data1 ? data1 : null} changeInverted={false} context="l2"/>
                        </Widget>
                    </>
                    : data1 && data1.onlyOneValue === true 
                        ?   <Widget title={data1.name} showHeader={false} renderActions={() => (<></>)}>
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <OverlayTrigger placement="right" delay={{ show: 100, hide: 200 }} overlay={
                                            <Tooltip id={`tooltip-${data1.name}`}>
                                                {data1.description}
                                            </Tooltip>}
                                        >
                                            <FontAwesomeIcon icon={faInfoCircle} className="mr-1 text-sm text-muted" style={{ cursor: 'pointer' }} />
                                        </OverlayTrigger>
                                        <span className="font-weight-light text-capitalize text-xl">{data1.name}</span>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <span className="font-weight-bold text-capitalize text-lg">&nbsp;{dcRound(data1.singleValue, undefined, undefined, true)}</span><span className="font-weight-light text-capitalize text-sm">&nbsp;{` (${data1.singleDate.split("T")[0]})`}</span>
                                </div>
                            </Widget>
                        :   <></> 
                    }
                    {
                    ( dataSpark2 && data2 && sparkWidth2 && sparkWidth2 > 0 && data2.onlyOneValue === false)
                    ? <>
                        <Widget title={data2.name} showHeader={false} renderActions={() => (<></>)}>
                            <Stats year={settings[SETTING_SEASON_YEAR]} dateSelected={dateSelected} loading={loading} metric={data2.name} description={data2.description} data={data2 ? data2 : null} changeInverted={false} context="l2"/>
                        </Widget>
                    </>
                    : data2 && data2.onlyOneValue === true 
                        ?   <Widget title={data2.name} showHeader={false} renderActions={() => (<></>)}>
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <OverlayTrigger placement="right" delay={{ show: 100, hide: 200 }} overlay={
                                            <Tooltip id={`tooltip-${data2.name}`}>
                                                {data2.description}
                                            </Tooltip>}
                                        >
                                            <FontAwesomeIcon icon={faInfoCircle} className="mr-1 text-sm text-muted" style={{ cursor: 'pointer' }} />
                                        </OverlayTrigger>
                                        <span className="font-weight-light text-capitalize text-xl">{data2.name}</span>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <span className="font-weight-bold text-capitalize text-lg">&nbsp;{dcRound(data2.singleValue, undefined, undefined, true)}</span><span className="font-weight-light text-capitalize text-sm">&nbsp;{` (${data2.singleDate.split("T")[0]})`}</span>
                                </div>
                            </Widget>
                        :   <></> 
                    }
                    {
                    ( dataSpark3 && data3 && sparkWidth3 && sparkWidth3 > 0 && dataSpark3[0] !== "Thermal" && data3.onlyOneValue === false)
                    ? <>
                        <Widget title={data3.name} showHeader={false} renderActions={() => (<></>)}>
                            <Stats year={settings[SETTING_SEASON_YEAR]} dateSelected={dateSelected} loading={loading} metric={data3.name} description={data3.description} data={data3 ? data3 : null} changeInverted={false} context="l2"/>
                        </Widget>
                    </>
                    :  data3 && data3.onlyOneValue === true 
                        ?   <Widget title={data3.name} showHeader={false} renderActions={() => (<></>)}>
                                <div className="d-flex justify-content-between">
                                    <div className="d-flex align-items-center">
                                        <OverlayTrigger placement="right" delay={{ show: 100, hide: 200 }} overlay={
                                            <Tooltip id={`tooltip-${data3.name}`}>
                                                {data3.description}
                                            </Tooltip>}
                                        >
                                            <FontAwesomeIcon icon={faInfoCircle} className="mr-1 text-sm text-muted" style={{ cursor: 'pointer' }} />
                                        </OverlayTrigger>
                                        <span className="font-weight-light text-capitalize text-xl">{data3.name}</span>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center">
                                    <span className="font-weight-bold text-capitalize text-lg">&nbsp;{dcRound(data3.singleValue, undefined, undefined, true)}</span><span className="font-weight-light text-capitalize text-sm">&nbsp;{` (${data3.singleDate.split("T")[0]})`}</span>
                                </div>
                            </Widget>
                        :   <></> 
                    }
                    </>
                }
            </dd>
        </div>
    );
}

export default AboveWidget3SparkCell;